import React, { useState } from "react";
import { C } from "../theme";

// Small round profile avatar. Shows the user's uploaded photo when available,
// otherwise falls back to their initials on a brand-gradient disc. Used in the
// dashboard header (inconspicuous) and the User Preferences "Profile Photo" row.

function initialsFrom(name) {
  const parts = String(name || "").trim().split(/\s+/).filter(Boolean);
  if (!parts.length) return "";
  if (parts.length === 1) return parts[0].slice(0, 1).toUpperCase();
  return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
}

export default function ProfileAvatar({
  url = "",
  name = "",
  size = 32,
  onClick,
  title,
  style = {},
}) {
  const [failed, setFailed] = useState(false);
  const showImg = Boolean(url) && !failed;
  const initials = initialsFrom(name);

  const base = {
    width: size,
    height: size,
    borderRadius: "50%",
    overflow: "hidden",
    flexShrink: 0,
    border: `1px solid ${C.seafoam}66`,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: 0,
    boxSizing: "border-box",
    background: showImg
      ? C.cardBg
      : `linear-gradient(135deg, ${C.accent}, ${C.teal})`,
    color: C.white,
    fontFamily: "Georgia,serif",
    fontWeight: 700,
    fontSize: Math.max(9, Math.round(size * 0.4)),
    lineHeight: 0,
    cursor: onClick ? "pointer" : "default",
    ...style,
  };

  const inner = showImg ? (
    <img
      src={url}
      alt={name ? `${name} profile photo` : "Profile photo"}
      onError={() => setFailed(true)}
      style={{ width: "100%", height: "100%", objectFit: "cover", display: "block" }}
    />
  ) : (
    <span aria-hidden style={{ lineHeight: 1 }}>{initials || "\u2022"}</span>
  );

  if (onClick) {
    return (
      <button type="button" onClick={onClick} title={title} aria-label={title || "Profile"} style={base}>
        {inner}
      </button>
    );
  }
  return (
    <div title={title} aria-label={title || "Profile photo"} style={base}>
      {inner}
    </div>
  );
}
